export function HomeScreen() {
  return (
    <div className="kstc-card kst-card-width">
      <div className="kstc-card__body">
        <h5 className="kstc-card__title">Download Reports</h5>
        <p className="kstc-card__text">
          Welcome to the security client portal. <br /><br />
          Here you can download reports for your records or to stay up-to-date.
        </p>
      </div>
    </div>
  );
}
